import styled from 'styled-components';
import { TableRow } from '../../../../../CommonComponents/OPL/Table/Table';
import { Theme } from '../../../../../theme/theme';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface ModelRowProps {
  theme: Theme;
  isDragging: boolean;
}

export const ModelRow = styled(TableRow)(({ theme, isDragging }: ModelRowProps) => ({
  background: theme.colors.bg,
  marginTop: -1,
  borderTop: isDragging
    ? `1px solid ${theme.colors.primary['500']}`
    : `1px solid ${theme.colors.neutral['200']}`,
  borderBottom: isDragging
    ? `1px solid ${theme.colors.primary['500']}`
    : `1px solid ${theme.colors.neutral['200']}`,
  borderLeft: isDragging ? `1px solid ${theme.colors.primary['500']}` : 'none',
  borderRight: isDragging ? `1px solid ${theme.colors.primary['500']}` : 'none',
  boxShadow: isDragging ? theme.shadows['500'] : 'none',

  '&:last-of-type': {
    borderBottom: isDragging ? `1px solid ${theme.colors.primary['500']}` : 'none',
  },
}));

interface ModelsWrapperProps {
  hasModels: boolean;
  isReadonly?: boolean;
  isUsingPlaceholder: boolean;
}

export const ModelsWrapper = styled(Box)<ModelsWrapperProps>(
  ({ theme, hasModels, isReadonly, isUsingPlaceholder }) => ({
    background: hasModels ? theme.colors.neutral['200'] : 'bg',
    maxHeight: !isReadonly ? '20vh' : undefined,
    overflowY: !isReadonly ? 'auto' : undefined,
    borderBottom:
      hasModels && !isUsingPlaceholder ? `1px solid ${theme.colors.neutral['200']}` : 'none',

    '@media (min-height: 700px)': {
      maxHeight: !isReadonly ? '40vh' : undefined,
    },

    '@media (min-height: 900px)': {
      maxHeight: !isReadonly ? '50vh' : undefined,
    },
  }),
);
